import getScrollbarWidth from '../../js/modules/getscrollbarwidth.js'
import debounce from '../../js/modules/debounce'
import isSiteInMobileMode from '../../js/modules/mt-isSiteInMobileMode.js'
import hasScrollBar from '../../js/modules/hasscrollbar.js'
import isMobileDevice from '../../js/modules/ismobiledevice.js'
import smallestViewportDimension from '../../js/modules/smallestviewportdimension.js'

// this import is to help with loading google adsense advertisements that can't load if they are hidden, causing console errors and possibly memory leaks.
import refreshlazyads from '../../js/modules/lazyloadadvertisements.js'

// Tabs component mostly based on this code from: https://github.com/alexgleason/tabs.js/blob/master/tabs.js

// Tabs&Accordion component
// This all has to be run after document-ready because some parts aren't pre-document-ready-safe
// The tabs solution is pretty custom to this project.
// Depending on the dimensions of the device or whether the device is touch or not we may show an Accordion instead of Tabs.
// This code has not been fully tested for multiple instances of tabs on a page.
// The design only calls for 1 set of tabs on a page so the code and testing has been kept as simple as possible.
// Long term: I would rather either find a solution that covers our design constraints or extend this code to be more general.

export default function () {
  const small_med_breakpoint = 730
  const tabsClass = 'tabs'
  const tabClass = 'tab'
  const tabButtonClass = 'tab-button'
  const activeClass = 'active'
  const scrollTransitionTime = 400
  const tabbedContainers = document.body.querySelectorAll('.' + tabsClass)

  function isSiteInSmallMode () {
    return document.documentElement.clientWidth < small_med_breakpoint
  }

  // Activates the chosen tab and deactivates the rest
  function activateTab (chosenTabElement) {
    let tabList = chosenTabElement.parentNode.querySelectorAll('.' + tabClass)
    for (let i = 0; i < tabList.length; i++) {
      let tabElement = tabList[i]
      if (tabElement.isEqualNode(chosenTabElement)) {
        tabElement.classList.add(activeClass)
      } else {
        tabElement.classList.remove(activeClass)
      }
    }
  }

  // ToDo maybe: Could probably replace this for loop with .map somehow
  // Initialize each tabbed container
  for (let i = 0; i < tabbedContainers.length; i++) {
    let tabbedContainer = tabbedContainers[i]

    // List of tabs for this tabbed container
    let tabList = tabbedContainer.querySelectorAll('.' + tabClass)

    // Make the first tab active when the page loads
    activateTab(tabList[0])

    // Activate a tab when you click its button
    for (let i = 0; i < tabList.length; i++) {
      let tabElement = tabList[i]
      let tabButton = tabElement.querySelector('.' + tabButtonClass)
      tabButton.addEventListener('click', function (event) {
        event.preventDefault()
        activateTab(event.target.parentNode)
      })
    }
  }

  // This shouldBeTabs function is pretty specific to this project.
  // First we try to detect whether the device is a touch device or not.
  // Then we decide whether the tabs on the page should be tabs or accordions depending on the device dimensions.
  function shouldBeTabs () {
    if (isMobileDevice()) {
      if (smallestViewportDimension() < small_med_breakpoint + 100) {
        // Should be accordion
        return false
      } else {
        // Should be tabs
        return true
      }
    } else {
      if (isSiteInMobileMode()) {
        // Should be accordion
        return false
      } else {
        // Should be tabs
        return true
      }
    }
  }

  // Call this to make tabs.
  function makeTabs () {
    $('.tabs').addClass('tabs--tabmode')
    $('.tabs').prepend('<div class="tabs__navcontainer"><div class="tabs__nav">')
    var tabnav = $('.tabs .tabs__nav')
    tabnav.css({'height': tabnav.parent().height() + getScrollbarWidth()})
    $('.tab-button').each(function () {
      $(this).closest('.tab').attr('data-tabname', $(this).text())
      tabnav.append('<div class="tab-button" data-tabbutton="' + $(this).text() + '">' + $(this).text() + '</div>')
      $(this).remove()
    })
    $('.tab-button').first().addClass('active')

    // Set the style classes on the tab buttons when they're clicked.
    $('.tabs__nav div').click(function () {
      $('.tabs__nav div').removeClass('active')
      $(this).addClass('active')
      var tabname = $(this).attr('data-tabbutton')
      $('.tab').removeClass('active')
      $('.tab[data-tabname="' + tabname + '"]').addClass('active')

      refreshlazyads()
    })

    // If there are enough tab buttons to create a scroll bar then add another style class (Specifically: in the design there is a little arrow in the nav we need to add in this situation).
    // Also add a button so that the tabs can be scrolled with a tap/click
    $('.tabs__nav').each(function () {
        // if (hasScrollBar($(this)).horizontal) {
      const navbuttons = $(this)
      const navcontainer = navbuttons.parent()
      const scrollbuttonnextclass = 'tabs__scroll-next'
      const scrollbuttonprevclass = 'tabs__scroll-prev'

      navcontainer.addClass('js-scrollbar-detected')
      navcontainer.append('<button class="' + scrollbuttonnextclass + '">')
      navcontainer.append('<button style="display:none;" class="' + scrollbuttonprevclass + '">')

      // when the new scroll-next button is clicked scroll the tabs navigation along horizontally.
      const scrollnextbutton = navcontainer.children('.' + scrollbuttonnextclass)
      const scrollprevbutton = navcontainer.children('.' + scrollbuttonprevclass)

      scrollnextbutton.click(function () {
        const widthtoscroll = navcontainer[0].offsetWidth - 100
        const widthtoscrollstring = '+=' + widthtoscroll + 'px'

        navbuttons.animate({scrollLeft: widthtoscrollstring}, scrollTransitionTime)
        // if this is clicked then show the hidden prev button
        scrollprevbutton.css({'display': 'block'})
        window.setTimeout(function () {
          tabsaccordionCheckScrollPosition()
        }, (scrollTransitionTime + 100))
      })

      scrollprevbutton.click(function () {
        const widthtoscroll = navcontainer[0].offsetWidth - 100
        const widthtoscrollstring = '-=' + widthtoscroll + 'px'

        navbuttons.animate({scrollLeft: widthtoscrollstring}, scrollTransitionTime)
        window.setTimeout(function () {
          tabsaccordionCheckScrollPosition()
        }, (scrollTransitionTime + 100))
      })

      var tabsaccordionCheckScrollPosition = debounce(function () {
        requestAnimationFrame(function () {
          if (navbuttons.scrollLeft() <= 40) {
            scrollprevbutton.fadeOut()
          }
          if (navbuttons.scrollLeft() > 40) {
            scrollprevbutton.fadeIn()
          }
          if (navbuttons.scrollLeft() + navbuttons.innerWidth() >= navbuttons[0].scrollWidth - 40) {
            scrollnextbutton.fadeOut()
          }
          if (navbuttons.scrollLeft() + navbuttons.innerWidth() < navbuttons[0].scrollWidth - 40) {
            scrollnextbutton.fadeIn()
          }
        }, 250)
      })
      tabsaccordionCheckScrollPosition()

      // If the viewport changes we need to re-evaluate the scroll status
      window.addEventListener('resize', tabsaccordionCheckScrollPosition)
    })
  }

  // Call this to make Accordion.
  function makeAccordion () {
    $('.tabs').addClass('tabs--accordionmode')
    $('.tabs .tab-content').hide()
    $('.tabs .tab-button').addClass('js-closed')
    $('.tabs .tab-button').each(function () {
      const tabbutton = $(this)
      const tabcontent = tabbutton.next('.tab-content')

      tabbutton.click(function () {
        if (tabbutton.hasClass('js-closed')) {
          tabbutton.addClass('js-open').removeClass('js-closed')
          tabcontent.slideDown()
          setTimeout(refreshlazyads, 1000)
        } else {
          tabbutton.addClass('js-closed').removeClass('js-open')
          tabcontent.slideUp()
          setTimeout(refreshlazyads, 1000)
        }
      })
    })
  }

  // Start of the tabs or accordion logic.
  $(document).ready(function () {
    // First, use the shouldBeTabs function to decide whether the view should be tabs or an accordion.
    if (shouldBeTabs()) {
      // If shouldBeTabs() == true the view should be Tabs
      makeTabs()
    } else {
      // Else shouldBeTabs() == false and the view should be Accordion
      makeAccordion()
    }
  })
}
